import request from "../request";

export const getPeriodicalReport = (params) =>
  request.post(`/periodical-report/list`, params).then((res) => res);

export const getPeriodicalReportSkipLimit = (skip = 0, limit = 5, params) =>
  request.post(`/periodical-report/list/skip/${skip}/limit/${limit}`, params).then((res) => res);

export const getPeriodicalReportById = (periodicalReportId) =>
  request.get(`/periodical-report/${periodicalReportId}`).then((res) => res);

export const createPeriodicalReport = (data) =>
  request.post(`/periodical-report`, data).then((res) => res);

export const clonePeriodicalReport = (periodicalReportId) =>
  request.put(`/periodical-report/${periodicalReportId}/clone`).then((res) => res);

export const updatePeriodicalReport = (periodicalReportId, type, data) =>
  request.put(`/periodical-report/${periodicalReportId}/${type}`, data).then((res) => res);

export const setAsCurrentPeriodicalReport = (periodicalReportId) =>
  request.put(`/periodical-report/${periodicalReportId}/current`).then((res) => res);

export const addAssessmentAreaToPeriodicalReport = (periodicalReportId, data) =>
  request.post(`/periodical-report/${periodicalReportId}/assessment-areas`, data).then((res) => res);

export const updateAssessmentAreaToPeriodicalReport = (periodicalReportId, assessmentAreaId, data) =>
  request.put(`/periodical-report/${periodicalReportId}/assessment-areas/${assessmentAreaId}`, data).then((res) => res);

export const removeAssessmentAreaFromPeriodicalReport = (periodicalReportId, assessmentAreaId) =>
  request.delete(`/periodical-report/${periodicalReportId}/assessment-areas/${assessmentAreaId}`).then((res) => res);

export const generatePeriodicalReportMarking = (periodicalReportId) => 
  request.post(`/periodical-report/${periodicalReportId}/assessment-areas/generate-table-marking`).then((res) => res);

export const generatePeriodicalReportMarkingByAssessmentArea = (periodicalReportId, assessmentAreaId) =>
  request.post(`/periodical-report/${periodicalReportId}/assessment-areas/${assessmentAreaId}/generate-table-marking`).then((res) => res);

export const deletePeriodicalReport = (periodicalReportId) =>
  request.delete(`/periodical-report/${periodicalReportId}`).then((res) => res);

export const generatePeriodicalReportXML = (periodicalReportId, data) =>
  request.post(`/periodical-report/${periodicalReportId}/xml`, data).then((res) => res);
